import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { providePrimeNG } from 'primeng/config';
// import Aura from '@primeng/themes/aura';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import MyPreset from '../assets/kavach.theme';
import { MessageService } from 'primeng/api';
import { StationDetailsSyncService } from './components/survey-stepper/services/station-details-sync-service';
import { ErrorInterceptor } from './station-track-visualizer/services/error.service';
import { GlobalErrorHandler } from './components/export-dwg/core/services/global-error-handler.service';
import { PimCacheInterceptor } from './components/export-dwg/shared/services/pim-cache/pim-cache.interceptor';
import { WorkflowIndexedDbService } from '../../../usermgmt/src/lib/services/workflow-indexed-db.service';

export const appConfig: ApplicationConfig = {
  providers: [
    StationDetailsSyncService,
    provideAppInitializer(() => inject(WorkflowIndexedDbService).initialize()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector : '.dark',
          cssLayer: {
            name: 'primeng',
            order: 'app-styles, primeng, another-css-library',
          },
        },
      }
    }),
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      // Serves repeated Export-DWG step reads from memory instead of the
      // network. Inert until the stepper holds the draft's edit lock, so for
      // every other page in the app this is a no-op — see PimCacheInterceptor.
      provide: HTTP_INTERCEPTORS,
      useClass: PimCacheInterceptor,
      multi: true
    }
  ]
};
